export const COOKIE_GA_CONSENT_KEY = 'pt_ga_consent';
export const COOKIE_BANNER_DURATION_DAYS = 365;
